export default __webpack_public_path__ + "static/Hl1QhJef.css";